import { LEVELS } from '../constants/levels.js';
import { C } from '../constants/colors.js';

export function shuffle(a) {
  const b = [...a];
  for (let i = b.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [b[i], b[j]] = [b[j], b[i]];
  }
  return b;
}

export function rb(a, b) { return a + Math.random() * (b - a); }

export function getExpGrade(age) {
  if (age <= 4) return 0;
  if (age === 5) return .5;
  if (age === 6) return 1;
  if (age === 7) return 2;
  if (age === 8) return 3;
  if (age === 9) return 4;
  if (age === 10) return 5;
  return 6;
}

export function getPace(level, age) {
  const e = getExpGrade(age);
  const a = (LEVELS[level] || LEVELS[3]).gradeNum;
  if (a > e + .5) return { label: "Above Grade Level", color: C.success, emoji: "🚀", bg: C.successLight };
  if (a >= e - .5) return { label: "On Grade Level", color: "#F59E0B", emoji: "✅", bg: "#FFF8E1" };
  return { label: "Building Up", color: C.primary, emoji: "💪", bg: C.primaryLight };
}

export function todayStr() {
  const d = new Date();
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

export function getRecommendedTimer(age) {
  if (age <= 5) return 10;
  if (age <= 8) return 15;
  return 20;
}

export function getWeekDates(weekOffset) {
  const now = new Date();
  const dow = now.getDay();
  const dToMon = dow === 0 ? -6 : 1 - dow;
  const mon = new Date(now);
  mon.setDate(now.getDate() + dToMon + (weekOffset || 0) * 7);
  mon.setHours(0, 0, 0, 0);
  const days = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(mon);
    d.setDate(mon.getDate() + i);
    days.push(d);
  }
  return days;
}

export function sightFontSize(word, base) {
  const len = (word || "").length;
  if (len <= 8) return base;
  return Math.max(18, Math.round(base * (8 / len)));
}
